import React, {useState} from "react";
import { Package, PlusCircle, Edit, Plus} from "feather-icons-react/build/IconComponents";
import { all_routes } from "../../../Router/all_routes";
import SessionControl from "../../components/SessionControl/sessioncontrol";
import CheckRestauSelected from "../../components/SessionControl/checkrestauselected";


const RawMaterial = () => {
    const route = all_routes;
    const [showAddModal, setShowAddModal] = useState(false);

    // Fermer les modals
      const closeAddModal = () => {
        setShowAddModal(false);
        //setNewUser({ nom: "", unité: ""});
      };

    return (
        <div className="page-wrapper">
                <SessionControl
                    storageKey="user"
                    propsup="email"
                    redirectTo={route.signin}
                />
                <CheckRestauSelected
                    storageKey="user"
                    redirectTo={route.Restaurants}
                />
              
            <div className="content">
                <div className="page-btn d-flex justify-content-between align-items-center">
                  <div>
                    <h2><Package className="me-2" />Matières Premières</h2>
                    <h6>Gestion des matières premières</h6>
                  </div>
                  <button 
                    className="btn btn-added"
                    onClick={() => setShowAddModal(true)}
                  >
                    <PlusCircle className="me-2 iconsize" size={16} />
                    <span className="d-none d-md-inline">Ajouter un ingrédient</span>
                    <span className="d-md-none">Ajouter</span>
                  </button>
                  
                </div>
        
                {/* Liste des cuisiniers */}
                <div className="card table-list-card mt-4">
                  <div className="card-header">
                    <h5 className="mb-0 d-flex justify-content-between align-items-center">
                      Liste des Ingrédients
                      <span className="badge bg-primary">0</span>
                    </h5>
                  </div>
                  <div className="card-body">
                      <div className="table-responsive">
                        <table className="table table-hover mb-0">
                          <thead className="table-light">
                            <tr>
                              <th className="w-auto" >#</th>
                              <th className="w-auto" >Nom</th>
                              <th className="w-auto" >Unité</th>
                              <th className="w-25" >Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr >
                                <td className="w-auto" > 1 </td>
                                <td className="w-auto" > Riz </td>
                                <td className="w-auto" > 100g </td>
                                <td className="w-25" >
                                  <button 
                                    className="btn btn-sm btn-outline-primary"
                                    //onClick={() => openEditModal(utilisateur)}
                                    title="Modifier la matière première"
                                    onClick={() => setShowAddModal(true)}
                                    style={{
                                      borderRadius: '6px',
                                      padding: '6px 10px',
                                      border: '1px solid #007bff',
                                      backgroundColor: 'transparent',
                                      color: '#007bff',
                                      transition: 'all 0.2s ease'
                                    }}
                                  >
                                    <Edit size={14} />
                                  </button>
                                </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                  </div>
                </div>

                {showAddModal && (
                    <div 
                    className="modal fade show" 
                    style={{ display: 'block' }} 
                    tabIndex="-1"
                    >
                    <div className="modal-dialog modal-dialog-centered">
                        <div 
                        className="modal-content content gradient-modal" 
                        style={{ 
                            borderRadius: "20px",
                            backgroundColor: "#fff",
                            zIndex: 1055,
                            width: "100%",
                            position: "fixed",
                            bottom: "0",
                            left: "0",
                            margin: "0",
                            padding: "20px"
                        }}
                        >
                        <form>
                            <div className="modal-header border-0">
                            <div className="page-title">
                                <h4>
                                <Plus className="me-2" size={20} />
                                Ajouter une nouvelle matière première
                                </h4>
                            </div>
                            {/* <button
                                type="button"
                                className="btn-close"
                                onClick={closeAddModal}
                                disabled={loading}
                            >
                                <span aria-hidden="true">×</span>
                            </button> */}
                            </div>
                            
                            <div 
                            className="modal-body border-0"
                            style={{
                                maxHeight: "60vh", 
                                overflowY: "auto",
                                overflowX: "hidden",
                            }}
                            >        
                                <div className="row">
                                    <div className="col-lg-6 col-sm-6 col-12">
                                        <div className="input-blocks">
                                            <label className="form-label">Nom</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-sm-6 col-12">
                                        <div className="input-blocks">
                                            <label className="form-label">Unité</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                            />                                                  
                                        </div>
                                    </div>
                                </div>
                            </div>                                            
                            <div className="modal-footer-btn custom-modal-body">
                            <button 
                                type="button"
                                className="btn btn-cancel"
                                style={{ float: "left" }}
                                onClick={closeAddModal}
                            >
                                Annuler
                            </button>
                            <button 
                                type="submit" 
                                className="btn btn-primary"
                                style={{ marginTop: "-1px"}}
                            >
                                <>
                                    <Plus className="me-2" size={16} />
                                    Enregistrer
                                </>
                            </button>
                            </div>
                        </form>
                        </div>
                    </div>
                    </div>
                )}
            </div>
        </div>
  )
};

export default RawMaterial;